module.exports = __webpack_public_path__ + "static/media/galdinsWon_10000_25000.85a38d50.png";